"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { ChevronLeft, X } from "lucide-react";
import type { TooltipRenderProps } from "react-joyride";
import { Button } from "@/components/ui/button";
import type { TourStepData } from "@/features/onboarding-tours/types/tour-definition";
import { cn } from "@/lib/utils";
function getTourStepData(step: TooltipRenderProps["step"]): TourStepData {
  return (step.data ?? {}) as TourStepData;
}
export function TourTooltip(t0) {
  const $ = _c(32);
  const {
    step,
    index,
    size,
    backProps,
    primaryProps,
    skipProps,
    tooltipProps
  } = t0;
  let t1;
  if ($[0] !== step) {
    t1 = getTourStepData(step);
    $[0] = step;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const stepData = t1;
  const showControls = stepData.showControls !== false;
  const showSkip = stepData.showSkip !== false;
  const hidePrimary = stepData.hidePrimary === true;
  const isFirstStep = index === 0;
  const isLastStep = index === size - 1;
  const showControlFooter = showControls && (!isFirstStep || !hidePrimary);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("relative w-[min(100vw-2rem,18rem)] max-h-[calc(100vh-2rem)] overflow-y-auto", "rounded-xl bg-background/95", "shadow-[0_1px_2px_oklch(0_0_0/0.04),0_8px_24px_-6px_oklch(0_0_0/0.08)]", "backdrop-blur-sm motion-safe:animate-in motion-safe:fade-in-0", "motion-safe:zoom-in-95 motion-safe:duration-200");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div aria-hidden={true} className="pointer-events-none absolute inset-0 bg-linear-to-br from-primary/10 via-background to-orange/15" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = index + 1;
  let t5;
  if ($[4] !== size || $[5] !== t4) {
    t5 = <p className="text-[10px] font-medium uppercase tracking-[0.14em] text-muted-foreground/80">Step {t4} of {size}</p>;
    $[4] = size;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== step.title) {
    t6 = <h2 className="text-sm font-semibold leading-snug tracking-tight text-foreground">{step.title}</h2>;
    $[7] = step.title;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="min-w-0">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== showSkip || $[13] !== skipProps) {
    t8 = showSkip ? <Button {...skipProps} aria-label="Skip tour" className="size-7 shrink-0 text-muted-foreground hover:text-foreground -mr-2" size="icon" type="button" variant="ghost"><X className="size-3.5" /></Button> : null;
    $[12] = showSkip;
    $[13] = skipProps;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="relative overflow-hidden rounded-t-xl">{t3}<div className="relative flex items-start justify-between gap-2 px-4 pb-2 pt-3">{t7}{t8}</div></div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== step.content) {
    t10 = <div className="px-4 pt-2.5 pb-2.5 text-sm leading-snug text-muted-foreground">{step.content}</div>;
    $[18] = step.content;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== backProps || $[21] !== hidePrimary || $[22] !== isFirstStep || $[23] !== isLastStep || $[24] !== primaryProps || $[25] !== showControlFooter) {
    t11 = showControlFooter ? <div className="flex items-center justify-between gap-2 border-t border-border/50 px-3 py-2.5"><Button {...backProps} className={cn("gap-0.5", isFirstStep && "invisible")} disabled={isFirstStep} size="sm" type="button" variant="outline"><ChevronLeft className="size-3.5" />Back</Button>{hidePrimary ? null : <Button {...primaryProps} className="gap-1" size="sm" type="button" variant="default">{isLastStep ? "Finish" : "Next"}</Button>}</div> : null;
    $[20] = backProps;
    $[21] = hidePrimary;
    $[22] = isFirstStep;
    $[23] = isLastStep;
    $[24] = primaryProps;
    $[25] = showControlFooter;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t9 || $[30] !== tooltipProps) {
    t12 = <div {...tooltipProps} aria-modal="true" className={t2} data-tour-coachmark="" role="alertdialog">{t9}{t10}{t11}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t9;
    $[30] = tooltipProps;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
}